module.exports = __webpack_public_path__ + "img/dialogBg.12ee7329.png";